

export const LOCALSTORAGE_KEY = {
    user: 'user',
}

